var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Command from '../Command';
import Signals from '../../signals/Signals';
import deviceSettingsUpdate from '../../requests/devices/deviceSettingsUpdate';
/**
 *
 */
var UpdateDeviceSettingsCommand = /** @class */ (function (_super) {
    __extends(UpdateDeviceSettingsCommand, _super);
    function UpdateDeviceSettingsCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param deviceModel DeviceModel
     * @param organisationId string
     * @param intl
     * @return {*}
     */
    UpdateDeviceSettingsCommand.prototype.execute = function (deviceModel, deviceSettings, organisationId, intl) {
        var obj = {};
        Object.keys(deviceSettings).forEach(function (key) {
            obj[key] = deviceSettings[key];
        });
        this.intl = intl;
        this.deviceModel = deviceModel;
        var promise = deviceSettingsUpdate(obj, organisationId, deviceModel.link_device_id);
        promise.then(this.then);
        return promise;
    };
    /**
     *
     * @param response
     */
    UpdateDeviceSettingsCommand.prototype.then = function (response) {
        Signals.ShowNotification.dispatch(this.intl.formatMessage({ id: 'notification.device.updated' }, Object(this.deviceModel)), 'dark', true);
    };
    return UpdateDeviceSettingsCommand;
}(Command));
export default UpdateDeviceSettingsCommand;
